import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import type { ConnectorListItem } from '../lib/types';

export default function Connectors() {
  const [list, setList] = useState<ConnectorListItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.listConnectors().then(setList).finally(() => setLoading(false));
  }, []);

  async function remove(id: string, name: string) {
    if (!confirm(`Delete connector "${name}"? The API key will stop working immediately.`)) return;
    await api.deleteConnector(id);
    setList((prev) => prev.filter((c) => c.id !== id));
  }

  if (loading) return <p className="muted">Loading…</p>;

  return (
    <div>
      <div className="card row spread">
        <div>
          <h3 style={{ margin: 0 }}>Connectors</h3>
          <p className="muted" style={{ margin: '4px 0 0' }}>
            Each connector is one configured ERP/CRM instance with its own API key and webhook secret.
          </p>
        </div>
        <Link to="/connectors/new"><button>+ New connector</button></Link>
      </div>

      {list.length === 0 ? (
        <div className="empty">No connectors yet. Create one to start receiving generation requests.</div>
      ) : (
        <div className="card">
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Active</th>
                <th>Created</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {list.map((c) => (
                <tr key={c.id}>
                  <td><span className="mono">{c.name}</span></td>
                  <td><span className="pill info">{c.type}</span></td>
                  <td>
                    {c.is_active
                      ? <span className="pill success">active</span>
                      : <span className="pill">disabled</span>}
                  </td>
                  <td className="muted mono">{c.created_at}</td>
                  <td style={{ textAlign: 'right' }}>
                    <button className="ghost danger" onClick={() => remove(c.id, c.name)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
